/* Bulk Menu v2 (sections/bulk-menu-v2.liquid). Vanilla JS, no jQuery.
 * Cart: GET /cart.js, POST /cart/add.js, POST /cart/change.js (by line key).
 * Theme sync: window.wetheme.updateCartDrawer(cart) after every change, and we listen to
 * "wetheme-cart-update" so changes made in the theme drawer show up here.
 * Never touches div#form / #variant_id / p#quantity (used by snippets/right-drawer.liquid). */
(function () {
  'use strict';

  var root = document.querySelector('[data-bm2]');
  if (!root || root.__bm2) return;
  root.__bm2 = true;

  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var products = {};            // variantId -> product data (from card JSON)
  var order = [];               // variant ids in page order
  var cart = null;
  var queue = Promise.resolve();
  var busy = {};                // variantId -> true while a request runs

  // ---------- helpers ----------
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[0] + (dec ? ds + parts[1] : '');
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    var tmp = document.createElement('textarea');
    tmp.innerHTML = moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, v);
    return tmp.value;
  }
  function priceCents(p) { return Number(p.price) || 0; } // variant.price | json = cents
  // Customer-facing strings come from locales (sections/bulk-menu-v2.liquid -> [data-bm2-i18n]); English fallbacks.
  var I18N = { error: 'Something went wrong. Please try again.', item_one: '{n} item', item_other: '{n} items', per_lb_slash: '/ per LB', lb: 'LB',
    remove_named: 'Remove {name}', pounds_of: 'Pounds of {name}', dec: 'Remove 1 LB of {name}', inc: 'Add 1 LB of {name}',
    other_one: 'Your cart also has {n} other item (cart total {total}).', other_other: 'Your cart also has {n} other items (cart total {total}).',
    view_cart: 'View cart', item: 'Item', added: '{name} added to your bulk order', qty: '{name}: {qty} LB', removed: '{name} removed',
    cleared: 'Selections cleared', calories: 'Calories', protein: 'Protein', carbs: 'Carbs', fat: 'Fat', nutri_note: 'Nutrition per LB.' };
  try { var i18nEl = root.querySelector('[data-bm2-i18n]'); if (i18nEl) { var loaded = JSON.parse(i18nEl.textContent); for (var k in loaded) { if (loaded[k] && loaded[k].indexOf('translation missing') === -1) I18N[k] = loaded[k]; } } } catch (e) {}
  function tr(key, vars) { var s = I18N[key] || ''; for (var v in (vars || {})) s = s.split('{' + v + '}').join(vars[v]).split('%' + v + '%').join(vars[v]); return s; }
  function pluralItems(n) { return tr(n === 1 ? 'item_one' : 'item_other', { n: n }); }
  function announce(msg) { var el = $('[data-bm2-live]'); if (el) { el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 30); } }

  function request(url, body) {
    var opts = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(ROOT_URL.replace(/\/$/, '') + url, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) { var err = new Error((data && (data.description || data.message)) || tr('error')); err.status = res.status; throw err; }
        return data;
      });
    });
  }
  function enqueue(fn) { var p = queue.then(fn, fn); queue = p.catch(function () {}); return p; }

  // ---------- data ----------
  $all('[data-bm2-product]').forEach(function (node) {
    try {
      var d = JSON.parse(node.textContent);
      d.id = String(d.id);
      if (!products[d.id]) { products[d.id] = d; order.push(d.id); }
    } catch (e) { /* ignore malformed */ }
  });

  function cartLines(variantId) {
    if (!cart) return [];
    return cart.items.filter(function (it) { return String(it.variant_id) === String(variantId); });
  }
  function cartQty(variantId) { return cartLines(variantId).reduce(function (s, it) { return s + it.quantity; }, 0); }

  // ---------- render ----------
  function renderActions(variantId) {
    var qty = cartQty(variantId);
    var p = products[variantId];
    $all('[data-bm2-actions][data-variant-id="' + variantId + '"]', document).forEach(function (el) {
      if (el.getAttribute('data-state') === 'soldout') return;
      el.setAttribute('data-state', qty > 0 ? 'added' : 'add');
      el.classList.toggle('is-busy', !!busy[variantId]);
      el.setAttribute('aria-busy', busy[variantId] ? 'true' : 'false');
      $all('button', el).forEach(function (b) { b.disabled = !!busy[variantId]; });
      var q = el.querySelector('[data-bm2-qty]'); if (q) q.textContent = qty;
      var t = el.querySelector('[data-bm2-line-total]');
      if (t && p) t.textContent = formatMoney(priceCents(p) * qty);
    });
  }
  function renderAllActions() { order.forEach(renderActions); }

  function renderSummary() {
    var list = $('[data-bm2-list]');
    var summary = $('[data-bm2-summary]');
    if (!list || !summary) return;
    var items = cart ? cart.items.filter(function (it) { return products[String(it.variant_id)]; }) : [];
    var others = cart ? cart.items.filter(function (it) { return !products[String(it.variant_id)]; }) : [];
    var count = items.reduce(function (s, it) { return s + it.quantity; }, 0);
    var subtotal = items.reduce(function (s, it) { return s + it.final_line_price; }, 0);

    var groups = {};
    var groupOrder = [];
    items.forEach(function (it) {
      var p = products[String(it.variant_id)];
      if (!groups[p.cat]) { groups[p.cat] = { label: p.catLabel, items: [] }; groupOrder.push(p.cat); }
      groups[p.cat].items.push(it);
    });
    var catRank = { proteins: 0, carbs: 1, veggies: 2 };
    groupOrder.sort(function (a, b) { return (catRank[a] || 9) - (catRank[b] || 9); });

    if (!items.length) {
      list.innerHTML = '<p class="bm2-summary__empty">' + esc(list.getAttribute('data-empty') || '') + '</p>';
    } else {
      list.innerHTML = groupOrder.map(function (cat) {
        var g = groups[cat];
        return '<div class="bm2-group"><div class="bm2-group__head"><h3 class="bm2-group__title">' + esc(g.label) + '</h3>' +
          '<button type="button" class="bm2-group__clear" data-bm2-clear="' + esc(cat) + '">Clear selections<span class="bm2-sr"> in ' + esc(g.label) + '</span></button></div>' +
          g.items.map(function (it) {
            var p = products[String(it.variant_id)];
            var isBusy = busy[String(it.variant_id)];
            return '<div class="bm2-line' + (isBusy ? ' is-busy' : '') + '" data-key="' + esc(it.key) + '" data-variant-id="' + esc(it.variant_id) + '">' +
              (p.thumb ? '<img class="bm2-line__img" src="' + esc(p.thumb) + '" alt="" width="55" height="56" loading="lazy">' : '<span class="bm2-line__img"></span>') +
              '<p class="bm2-line__name">' + esc(p.title) + '<small>' + formatMoney(priceCents(p)) + ' ' + esc(tr('per_lb_slash')) + '</small></p>' +
              '<div class="bm2-line__right"><p class="bm2-line__price">' + formatMoney(it.final_line_price) +
              '<button type="button" class="bm2-line__remove" data-bm2-line-remove aria-label="' + esc(tr('remove_named', { name: p.title })) + '"><svg class="bm2-icon" aria-hidden="true"><use href="#bm2-i-x"/></svg></button></p>' +
              '<div class="bm2-qty" role="group" aria-label="' + esc(tr('pounds_of', { name: p.title })) + '">' +
              '<button type="button" data-bm2-line-dec aria-label="' + esc(tr('dec', { name: p.title })) + '"><svg class="bm2-icon" aria-hidden="true"><use href="#bm2-i-minus"/></svg></button>' +
              '<span>' + it.quantity + ' ' + esc(tr('lb')) + '</span>' +
              '<button type="button" data-bm2-line-inc aria-label="' + esc(tr('inc', { name: p.title })) + '"><svg class="bm2-icon" aria-hidden="true"><use href="#bm2-i-plus"/></svg></button>' +
              '</div></div></div>';
          }).join('') + '</div>';
      }).join('');
    }

    var lineCount = items.length;
    $all('[data-bm2-count]').forEach(function (el) { el.textContent = pluralItems(lineCount) + (count ? ' · ' + count + ' ' + tr('lb') : ''); });
    $all('[data-bm2-bar-count]').forEach(function (el) { el.textContent = pluralItems(lineCount); });
    $all('[data-bm2-subtotal], [data-bm2-bar-total]').forEach(function (el) { el.textContent = formatMoney(subtotal); });
    $all('[data-bm2-checkout]').forEach(function (el) { el.setAttribute('aria-disabled', cart && cart.item_count > 0 ? 'false' : 'true'); });

    var other = $('[data-bm2-other]');
    if (other) {
      if (others.length && cart) {
        var otherQty = others.reduce(function (s, it) { return s + it.quantity; }, 0);
        other.innerHTML = esc(tr(otherQty === 1 ? 'other_one' : 'other_other', { n: otherQty, total: formatMoney(cart.total_price) })) + ' <a href="' + ROOT_URL.replace(/\/$/, '') + '/cart">' + esc(tr('view_cart')) + '</a>';
        other.hidden = false;
      } else { other.hidden = true; }
    }
    summary.classList.toggle('has-items', items.length > 0);
    document.documentElement.classList.toggle('bm2-bar-on', items.length > 0);
    if (!items.length) setSheet(false);
  }

  function render() { renderAllActions(); renderSummary(); }

  function syncTheme() {
    try { if (window.wetheme && typeof window.wetheme.updateCartDrawer === 'function' && cart) window.wetheme.updateCartDrawer(cart); } catch (e) { /* theme API missing */ }
  }

  function showError(variantId, msg) {
    $all('[data-bm2-actions][data-variant-id="' + variantId + '"] [data-bm2-msg]', document).forEach(function (el) {
      el.textContent = msg; el.hidden = false;
      clearTimeout(el.__t); el.__t = setTimeout(function () { el.hidden = true; }, 5000);
    });
    announce(msg);
  }

  // ---------- cart operations ----------
  function fetchCart() { return request('/cart.js').then(function (c) { cart = c; return c; }); }

  function run(variantId, op) {
    variantId = String(variantId);
    if (busy[variantId]) return Promise.resolve();
    busy[variantId] = true;
    render();
    return enqueue(function () {
      return op().then(function (c) { if (c && c.items) cart = c; else return fetchCart(); })
        .then(function () { syncTheme(); })
        .catch(function (err) {
          showError(variantId, err.message);
          return fetchCart().catch(function () {});
        })
        .then(function () { busy[variantId] = false; render(); });
    });
  }

  function addOne(variantId) {
    var p = products[String(variantId)];
    return run(variantId, function () {
      return request('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] }).then(function () {
        announce(tr('added', { name: p ? p.title : tr('item') }));
        return null; // refetch full cart
      });
    });
  }

  function setQty(variantId, qty) {
    var p = products[String(variantId)];
    return run(variantId, function () {
      var lines = cartLines(variantId);
      if (!lines.length) {
        if (qty <= 0) return Promise.resolve(null);
        return request('/cart/add.js', { items: [{ id: Number(variantId), quantity: qty }] }).then(function () { return null; });
      }
      // Put the whole quantity on the first line; zero any duplicates.
      var chain = request('/cart/change.js', { id: lines[0].key, quantity: Math.max(0, qty) });
      lines.slice(1).forEach(function (l) { chain = chain.then(function () { return request('/cart/change.js', { id: l.key, quantity: 0 }); }); });
      return chain.then(function (c) {
        announce(qty > 0 ? tr('qty', { name: p ? p.title : tr('item'), qty: qty }) : tr('removed', { name: p ? p.title : tr('item') }));
        return c;
      });
    });
  }

  function clearCat(cat) {
    var ids = order.filter(function (id) { return products[id].cat === cat && cartQty(id) > 0; });
    if (!ids.length) return;
    var updates = {};
    cart.items.forEach(function (it) { if (ids.indexOf(String(it.variant_id)) > -1) updates[it.key] = 0; });
    ids.forEach(function (id) { busy[id] = true; });
    render();
    enqueue(function () {
      return request('/cart/update.js', { updates: updates }).then(function (c) { cart = c; syncTheme(); announce(tr('cleared')); })
        .catch(function (err) { announce(err.message); return fetchCart(); })
        .then(function () { ids.forEach(function (id) { busy[id] = false; }); render(); });
    });
  }

  // ---------- events: actions (cards + modal) ----------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !root.contains(t) && !t.closest('[data-bm2-modal]')) return;

    var actions = t.closest('[data-bm2-actions]');
    if (actions) {
      var vid = actions.getAttribute('data-variant-id');
      if (t.closest('[data-bm2-add]')) { e.preventDefault(); addOne(vid); return; }
      if (t.closest('[data-bm2-inc]')) { e.preventDefault(); setQty(vid, cartQty(vid) + 1); return; }
      if (t.closest('[data-bm2-dec]')) { e.preventDefault(); setQty(vid, cartQty(vid) - 1); return; }
    }

    var line = t.closest('.bm2-line');
    if (line) {
      var lv = line.getAttribute('data-variant-id');
      if (t.closest('[data-bm2-line-inc]')) { setQty(lv, cartQty(lv) + 1); return; }
      if (t.closest('[data-bm2-line-dec]')) { setQty(lv, cartQty(lv) - 1); return; }
      if (t.closest('[data-bm2-line-remove]')) { setQty(lv, 0); return; }
    }
    var clear = t.closest('[data-bm2-clear]');
    if (clear) { clearCat(clear.getAttribute('data-bm2-clear')); return; }

    var open = t.closest('[data-bm2-open]');
    if (open) { var card = open.closest('[data-bm2-card]'); if (card) openModal(card.getAttribute('data-variant-id'), open); return; }

    if (t.closest('[data-bm2-checkout]') && (!cart || !cart.item_count)) { e.preventDefault(); }
  });

  // ---------- filter tabs ----------
  var tabs = $all('[data-bm2-filter]');
  var cats = $all('[data-bm2-cat]');
  var filterBar = $('[data-bm2-filterbar]');
  function applyFilter(key, scroll) {
    tabs.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bm2-filter') === key ? 'true' : 'false'); });
    cats.forEach(function (s) { s.hidden = !(key === 'all' || s.getAttribute('data-bm2-cat') === key); });
    if (scroll && filterBar) {
      var products = root.querySelector('.bm2-products');
      var top = products.getBoundingClientRect().top + window.pageYOffset - stickyTop();
      if (window.pageYOffset > top + 1) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    var active = tabs.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
    if (active && active.scrollIntoView && window.matchMedia('(max-width: 990px)').matches) {
      active.parentNode.scrollTo({ left: active.offsetLeft - 24, behavior: 'smooth' });
    }
  }
  tabs.forEach(function (b) { b.addEventListener('click', function () { applyFilter(b.getAttribute('data-bm2-filter'), true); }); });

  // ---------- sticky offset (theme header) ----------
  function stickyTop() {
    var h = 0;
    var candidates = document.querySelectorAll('#shopify-section-header, .header-section, header.site-header, .site-header, [data-section-type="header"]');
    Array.prototype.forEach.call(candidates, function (el) {
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > h && r.height < window.innerHeight / 2) h = r.bottom;
      }
    });
    return Math.max(0, Math.round(h));
  }
  function updateTop() {
    root.style.setProperty('--bm2-top', stickyTop() + 'px');
    if (filterBar) {
      var r = filterBar.getBoundingClientRect();
      filterBar.classList.toggle('is-stuck', r.top <= stickyTop() + 1 && window.pageYOffset > 200);
    }
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; updateTop(); }); } }, { passive: true });
  window.addEventListener('resize', updateTop);

  // Hero "Order Now"
  $all('[data-bm2-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      updateTop();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - stickyTop(), behavior: 'smooth' });
    });
  });

  // ---------- mobile summary sheet ----------
  var summaryEl = $('[data-bm2-summary]');
  var barBtn = $('[data-bm2-bar]');
  function setSheet(open) {
    if (!summaryEl || !barBtn) return;
    if (open && !summaryEl.classList.contains('has-items')) open = false;
    summaryEl.classList.toggle('is-open', open);
    barBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('bm2-lock', open && window.matchMedia('(max-width: 990px)').matches);
    if (open) { var c = $('[data-bm2-bar-close]'); if (c) c.focus(); }
  }
  if (barBtn) barBtn.addEventListener('click', function () { setSheet(!summaryEl.classList.contains('is-open')); });
  var closeSheet = $('[data-bm2-bar-close]');
  if (closeSheet) closeSheet.addEventListener('click', function () { setSheet(false); barBtn.focus(); });
  if (summaryEl) summaryEl.addEventListener('click', function (e) { if (e.target === summaryEl && summaryEl.classList.contains('is-open')) setSheet(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && summaryEl && summaryEl.classList.contains('is-open')) { setSheet(false); barBtn.focus(); } });
  window.matchMedia('(max-width: 990px)').addEventListener && window.matchMedia('(max-width: 990px)').addEventListener('change', function () { setSheet(false); });

  // ---------- details modal ----------
  var modal = $('[data-bm2-modal]');
  var lastFocus = null;
  function openModal(variantId, opener) {
    var p = products[String(variantId)];
    if (!modal || !p) return;
    lastFocus = opener || document.activeElement;
    var img = modal.querySelector('[data-bm2-m-img]');
    if (p.image) { img.src = p.image; img.alt = p.imageAlt || p.title; img.parentNode.hidden = false; } else { img.parentNode.hidden = true; }
    modal.querySelector('[data-bm2-m-cat]').textContent = p.catLabel + ' · sold by the pound';
    modal.querySelector('[data-bm2-m-title]').textContent = p.title;
    modal.querySelector('[data-bm2-m-short]').textContent = p.short || '';
    var n = p.nutrition || {};
    var cells = [[tr('calories'), n.cals, ''], [tr('protein'), n.protein, 'g'], [tr('carbs'), n.carbs, 'g'], [tr('fat'), n.fat, 'g']]
      .filter(function (c) { return c[1] !== null && c[1] !== undefined; });
    var nutri = modal.querySelector('[data-bm2-m-nutri]');
    nutri.innerHTML = cells.map(function (c) { return '<div><dt>' + c[0] + '</dt><dd>' + esc(c[1]) + c[2] + '</dd></div>'; }).join('') +
      (cells.length ? '<p class="bm2-nutri__note">' + esc(tr('nutri_note')) + '</p>' : '');
    nutri.hidden = !cells.length;
    modal.querySelector('[data-bm2-m-long]').textContent = p.long || '';
    modal.querySelector('[data-bm2-m-long-wrap]').hidden = !p.long;
    modal.querySelector('[data-bm2-m-ingr]').textContent = p.ingredients || '';
    modal.querySelector('[data-bm2-m-ingr-wrap]').hidden = !p.ingredients;
    var diet = (p.badgesHtml || '') + (p.halal ? '<span class="bm2-tag bm2-tag--halal"><svg class="bm2-icon" aria-hidden="true"><use href="#bm2-i-halal"/></svg>Halal</span>' : '');
    modal.querySelector('[data-bm2-m-diet]').innerHTML = diet;
    modal.querySelector('[data-bm2-m-diet-wrap]').hidden = !diet;
    modal.querySelector('[data-bm2-m-price]').textContent = formatMoney(priceCents(p));
    var slot = modal.querySelector('[data-bm2-m-actions]');
    var src = root.querySelector('[data-bm2-card][data-variant-id="' + p.id + '"] [data-bm2-actions]');
    slot.innerHTML = '';
    if (src) {
      var clone = src.cloneNode(true);
      $all('[id]', clone).forEach(function (el) { el.removeAttribute('id'); });
      slot.appendChild(clone);
    }
    renderActions(p.id);
    if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
    document.documentElement.classList.add('bm2-lock');
    var closeBtn = modal.querySelector('[data-bm2-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeModal() {
    if (!modal || !modal.hasAttribute('open')) return;
    if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open');
  }
  if (modal) {
    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('bm2-lock');
      var slot = modal.querySelector('[data-bm2-m-actions]'); if (slot) slot.innerHTML = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bm2-close]')) { closeModal(); return; }
      if (e.target === modal) closeModal(); // backdrop
    });
    // Keep Tab inside the dialog (native showModal already makes the page inert; this also covers the fallback).
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = $all('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])', modal).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // ---------- theme drawer → page ----------
  document.documentElement.addEventListener('wetheme-cart-update', function (e) {
    var c = e && e.detail && e.detail.cart;
    if (c && c.items) { cart = c; render(); }
    else fetchCart().then(render).catch(function () {});
  });

  // ---------- init ----------
  var listEl = $('[data-bm2-list]');
  if (listEl) { var empty = listEl.querySelector('.bm2-summary__empty'); if (empty) listEl.setAttribute('data-empty', empty.textContent); }
  updateTop();
  fetchCart().then(render).catch(function () { render(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart().then(render).catch(function () {}); });
})();
